import { autoinject } from "aurelia-framework";
import { Claims } from "../../../../../constants/authentication/claims";
import { RightShipDialogServiceConstants } from "../../../../../constants/basics/rightship-dialog.constants";
import { VesselDetailModel } from "../../../../../models/vessels/vessel.models";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@autoinject
export class HowToResolveRuleDialog {

    public canReportIssue: boolean;
    public canSubmitMissingPsc: boolean;
    public vesselModel: VesselDetailModel;
    public ruleCode: string;
    public resolveRuleDescription:string;

    constructor(private dialogClientService: DialogClientService, userClaimsService: UserClaimsService) {
        this.canReportIssue = userClaimsService.hasPermission(Claims.CanSubmitDataAboutVessel);
        this.canSubmitMissingPsc = userClaimsService.hasPermission(Claims.CanSubmitMissingPsc);
    }

    activate(args: { vessel: VesselDetailModel,  resolveRuleDescription:string }) {
        this.vesselModel = args.vessel;
        this.resolveRuleDescription = args.resolveRuleDescription;
    }

    reportIssue() {
        this.close();
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.ReportADataIssueDialog, this.vesselModel, true, false, false, "right");
    }

    submitMissingPsc() {
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.ListVesselPscsForCloseOutDialog, this.vesselModel, true, false, false, "right");
    }

    close() {
        this.dialogClientService.hide();
    }
}